<template>
  <div id="playground">
    <i-total-calendar
      :mode="calendarMode"
      :highlight="highlight"
      :date-click="onDayClick"
      @titleClick="handleTitleClick"
      @next="onDayClick"
      @prev="onDayClick"
    ></i-total-calendar>
    <div v-if="calendarMode === 'week'">
      <swipe-list
        v-if="bookingList.length>0"
        ref="swipeListRef"
        :disable-right-swipe="true"
        :items="bookingList"
      >
        <template v-slot="{ item, index, revealLeft, revealRight, close }">
          <div class="card-content">
            <v-list-item @click="handleRowClick(item,index)">
              <v-list-item-avatar
                size="large"
                rounded
                color="#a8a8a8"
              >
                <v-list-item-content class="time-span">
                  <div>{{ formatTime(item.courseStartTime) }}</div>
                  <div>~</div>
                  <div>{{ formatTime(item.courseEndTime) }}</div>
                </v-list-item-content>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-content> Course: {{ `${item.course.courseCode} ${item.course.courseName}` }} </v-list-item-content>
                <v-list-item-content> Coach: {{ item.assignedCoach.fullName }} </v-list-item-content>
                <v-list-item-content> Center: {{ item.center.description }} </v-list-item-content>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:right="{ item }">
          <!-- <div
            v-if="dateAfterChecking"
            class="swipeout-action deep-sky-blue"
            @click="handleQrcode(item)"
          >
            <v-icon
              large
              color="white"
            >
              mdi-qrcode
            </v-icon>
          </div>
          <div
            v-if="dateAfterChecking"
            class="swipeout-action dark-turquoise"
            @click="handleTransfer(item)"
          >
            <v-icon
              large
              color="white"
            >
              mdi-swap-horizontal
            </v-icon>
          </div>
          <div
            class="swipeout-action green-yellow"
            @click="handleAbnormal(item)"
          >
            <v-icon
              large
              color="white"
            >
              mdi-account-clock
            </v-icon>
          </div> -->
        </template>
      </swipe-list>
      <v-card
        v-if="bookingList.length==0"
        class="card-content"
      >
        <v-list-item>
          <v-list-item-content>
            list is empty ( filtered or just empty )
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <!-- <v-btn
        v-if="dateAfterChecking && enableCreateBooking"
        fab
        elevation="1"
        bottom
        right
        dark
        absolute
        color="#008800"
        @click="handleCreate"
      >
        <v-icon
          size="36"
          color="white"
        >
          mdi-plus
        </v-icon>
      </v-btn>
    </div> -->
      <!-- <v-dialog
      v-model="createBookingDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ createBookingTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleCreateBooking"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <create-booking
            ref="createBookingInfo"
            :selected-day="selectedDay"
          >
          </create-booking>
        </v-container>
      </v-card>
    </v-dialog> -->
      <!-- <v-dialog
      v-model="transferBookingDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ transferBookingTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleTransferBooking"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <transfer-booking
            ref="transferBookingRef"
            :booking-info="currentBooking"
          ></transfer-booking>

          <section v-if="bookingTransferList.length>0">
            <h2>Transfer Booking:</h2>
            <vue-horizontal
              scroll
              :button="false"
              class="horizontal"
            >
              <booking-transfer-item
                v-for="bookingTransfer in bookingTransferList"
                :key="bookingTransfer.id"
                :booking-transfer="bookingTransfer"
                @cancel="handleCancelTransfer"
                @loading="isLoading = true"
              ></booking-transfer-item>
            </vue-horizontal>
          </section>

        </v-container>
      </v-card>
    </v-dialog> -->
      <!-- <v-dialog
      v-model="abnormalAttendanceDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ abnormalAttendanceTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleAbnormalAttendance"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <abnormal-attendance
            ref="abnormalAttendanceRef"
            :booking-info="currentBooking"
          ></abnormal-attendance>
        </v-container>
      </v-card>
    </v-dialog> -->
      <v-dialog
        v-model="bookingInfoDialog"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="handleCloseDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ bookingInfoTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <booking-info-page
              ref="bookingInfoRef"
              :booking-info-prop="currentBooking"
              @canceled="handleCancel"
            ></booking-info-page>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- <v-dialog
      v-model="qrcodeDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="qrcodeDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ bookingInfoTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <course-qrcode
            :booking="currentBooking"
          ></course-qrcode>
        </v-container>
      </v-card>
    </v-dialog> -->
      <v-overlay
        :z-index="999"
        :value="isLoading"
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-snackbar
        v-model="msgToast"
      >
        {{ message }}
      </v-snackbar>
    </div>
  </div>
</template>
<script setup>
import { ref, nextTick, onMounted, computed } from 'vue'
import VueHorizontal from 'vue-horizontal'
import moment from '@/utils/moment'
import ITotalCalendar from '@/components/Calendar/ITotalCalendar'
import SwipeList from '@/components/SwipeList/SwipeList'
import { useStore } from '@/store'

import { getUserData } from '@/utils/auth'
import { createItem, listStudentBooking, cancel, getHighlight } from '@/api/bookedCourse'

// import BookingTransferItem from './BookingCalendar/components/BookingTransferItem'
import BookingInfoPage from './BookingCalendar/BookingInfoPage'

// import CourseQrcode from './BookingCalendar/CourseQrcode'
import { formatTime } from '@/utils/helper'

import '@/styles/swipelist.css'

const highlight = ref([])

function refreshHighlight() {
  getHighlight().then(res => {
    console.log('refreshHighlight', res)
    if (res.data.items) {
      highlight.value = res.data.items
    }
  })
}

const swipeListRef = ref(null)

// const enableCreateBooking = ref(false)
onMounted(() => {
  refreshHighlight()
})

const bookingInfoDialog = ref(false)

const isLoading = ref(false)
const msgToast = ref(false)
const message = ref('')
const bookingList = ref([
])
const selectedDay = ref('')

const dateAfterChecking = computed(() => moment(selectedDay.value).isAfter(moment().add(-1, 'days')))

function showMessage(msg) {
  message.value = msg
  msgToast.value = true
}

const defaultCalendarMode = 'twomonth'
const calendarMode = ref(defaultCalendarMode)
function handleTitleClick() {
  console.log('handleTitleClick', calendarMode.value)
  calendarMode.value = defaultCalendarMode
}

// const createBookingDialog = ref(false)
// const createBookingTitle = ref('Create Booking')

// const createBookingInfo = ref(null)
function fetchBooking() {
  return new Promise(resolve => {
    listStudentBooking({
      page: 0,
      limit: 0,
      courseDate: selectedDay.value,
      orderBy: 'CourseStartTime',

      // 1: normal 2: canceled 3: completed
      // fetch normal and completed record, filter canceled records
      courseStatusIDList: ['1', '3'],
    }).then(result => {
      console.log(result)
      const { items } = result.data
      bookingList.value = items
      resolve(items)
    })
  })
}

// const abnormalAttendanceDialog = ref(false)
// const abnormalAttendanceTitle = 'Abnormal Attendance'

// const transferBookingDialog = ref(false)
// const transferBookingTitle = 'Transfer Booking'

// function handleCreate() {
//   console.log('handleCreate')
//   createBookingDialog.value = true
// }

const currentBooking = ref({
  bookingNo: '',
  userRecord: {
    fullName: '',
  },
  center: {
    description: '',
  },
  courseDate: '',
  courseStartTime: '',
  courseEndTime: '',
})

const bookingInfoTitle = ref('Booking Information')

function handleRowClick(item, index) {
  if (swipeListRef.value.isRevealed === index) {
    swipeListRef.value.close()
  } else {
    currentBooking.value = { ...item }
    bookingInfoDialog.value = true
  }
}

const bookingInfoRef = ref(null)

// const transferBookingRef = ref(null)

// const bookingTransferList = ref([])

// function fetchBookingTransfers() {
//   console.log('fetchBookingTransfers currentBooking.id', currentBooking)
//   listBookingTransfers({
//     id: currentBooking.value.id,
//   }).then(response => {
//     console.log('listBookingTransfers', response)
//     bookingTransferList.value = response.data.items
//     isLoading.value = false
//   })
// }

// function handleCancelTransfer() {
//   fetchBookingTransfers()
//   showMessage('Transfer canceled!')
// }

// function handleTransferBooking() {
//   const transferData = transferBookingRef.value.getTransferData()
//   console.log('transferData', transferData)
//   isLoading.value = true
//   assignNewCoach(transferData).then(response => {
//     console.log('handleTransferBooking', response)

//     if (response.data && response.data.record) {
//       showMessage('Notification sent to target coach. Waiting for accept.')
//     }
//     fetchBookingTransfers()
//   })
// }

// function handleAbnormalAttendance() {
//   updateAbnormalAttendanceReason(currentBooking.value).then(response => {
//     console.log('updateAbnormalAttendanceReason', response)

//     if (response.code === 20000) {
//       showMessage('Updated')
//     }
//   })
// }

const abnormalAttendanceRef = ref(null)

function handleCloseDialog() {
  currentBooking.value = {
    bookingNo: '',
    course: {
      courseCode: '',
      courseName: '',
    },
    userRecord: {
      fullName: '',
    },
    center: {
      description: '',
    },
    courseStartTime: '',
    courseEndTime: '',
  }

  // if (createBookingInfo.value) {
  //   createBookingInfo.value.reset()
  // }
  // if (transferBookingRef.value) {
  //   transferBookingRef.value.reset()
  // }
  // if (abnormalAttendanceRef.value) {
  //   abnormalAttendanceRef.value.reset()
  // }

  // abnormalAttendanceDialog.value = false
  // transferBookingDialog.value = false
  // createBookingDialog.value = false
  bookingInfoDialog.value = false

  refreshHighlight()
}

function handleCancel() {
  isLoading.value = true
  fetchBooking().then(response => {
    isLoading.value = false
    showMessage('Booking canceled!')
    handleCloseDialog()
  })
}

function handleCreateBooking() {
  console.log('createBookingInfo.value.bookingInfo', createBookingInfo.value.bookingInfo)
  isLoading.value = true
  createItem(createBookingInfo.value.bookingInfo).then(response => {
    console.log('create response', response)
    if (response.code === 20000) {
      fetchBooking().then(bookings => {
        isLoading.value = false
        showMessage('Booking created.')
        handleCloseDialog()
      }).catch(error => {
        isLoading.value = false
        console.log('error', error)

        // handleCloseDialog()
      })
    }
  }).catch(error => {
    isLoading.value = false
    console.log('error', error)

    // handleCloseDialog()
  })
}

const qrcodeDialog = ref(null)
function handleQrcode(item) {
  console.log('handleQrcode', item)
  currentBooking.value = item
  qrcodeDialog.value = true
}
function handleTransfer(item) {
  transferBookingDialog.value = true
  console.log('handleTransfer', item)
  currentBooking.value = item

  // fetch bookingTransfer record
  fetchBookingTransfers()
}

// function handleAbnormal(item) {
//   abnormalAttendanceDialog.value = true
//   console.log('handleAbnormal', item)
//   currentBooking.value = item
// }

const studentList = ref([])

const store = useStore()
onMounted(() => {
  store.dispatch('course/list', {})
    .then(result => {
      console.log('course result', result)
    })
    .catch(err => {
      console.log('err', err)
    })
  const userData = getUserData()
  console.log('booking user data', userData)
  store.dispatch('center/list', {})
    .then(result => {
      console.log('center result', result)
    })
    .catch(err => {
      console.log('err', err)
    })
})

const enabled = ref(true)

const selectedOpen = ref(false)

function onDayClick(day) {
  console.log(day)
  selectedDay.value = day.date
  console.log('selectedDay.value', selectedDay.value)
  calendarMode.value = 'week'

  // showEvent()
  isLoading.value = true

  // fetchList({
  //   page: 1,
  //   limit: 20,
  //   courseDate: selectedDay.value,
  //   OrderBy: 'CourseStartTime',
  // }).then(response => {
  //   console.log(response)
  //   bookingList.value = response.data.items
  //   isLoading.value = false
  // })
  fetchBooking().then(response => {
    isLoading.value = false
  })
}
</script>
<style scoped>
.time-span {
  color: white
}

.horizontal >>> .v-hl-container {
  /* Space between content and scrollbar */
  /* padding-bottom: 16px; */

  /* For firefox only */
  scrollbar-width: thin;
  /* scrollbar-color: orangered black; */
}

.horizontal >>> .v-hl-container::-webkit-scrollbar {
  height: 0px;
  width: 16px;
  background: transparent;
}

</style>
